import { type NbaType } from "@repo/api";
import { FilterCheckbox, translateNbaType, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

// TODO: We should get this from configuration
export const enabledNba: NbaType[] = [
  "SET_EXPECTED_PURCHASE_DATE",
  "SET_ESTIMATED_BUDGET",
  "SET_SERVICES_INTERESTED",
];

export const NbaFilter = ({ actions, filters }: FilterItemsProps) => {
  const { language } = useSettings();
  return (
    <FilterListContainer id="nba-filter">
      {enabledNba
        .sort((a, b) => a.localeCompare(b, language))
        .map((nba) => (
          <FilterCheckbox
            key={nba}
            id={nba}
            value={nba}
            label={translateNbaType(nba)}
            checked={isChecked(filters.nbaTypes, nba)}
            onCheckFilter={actions.setNbaTypes}
          />
        ))}
    </FilterListContainer>
  );
};
